import * as React from "react";

import Box from "@material-ui/core/Box";

import lightBlue from "@material-ui/core/colors/lightBlue";
import { darken } from "@material-ui/core/styles/colorManipulator";

import { Container } from "./Container";

export const ColoredBandContainer = (
  props: React.PropsWithChildren<{ dark?: boolean; noGutter?: boolean }>
) => {
  const { dark, noGutter, children } = props;
  return (
    <Box
      mt={noGutter === true ? 0 : 8}
      py={4}
      bgcolor={dark === true ? darken(lightBlue[900], 0.3) : "#f7faff"}
    >
      <Container>{children}</Container>
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/components/PageWrapper/ColoredBandContainer.tsx